import { ReactNode } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';

interface PageLayoutProps {
  children: ReactNode;
  showWhatsApp?: boolean;
}

const PageLayout = ({ children, showWhatsApp = true }: PageLayoutProps) => (
  <div className="flex flex-col min-h-screen bg-black">
    <Navbar />
    <main className="flex-grow">{children}</main>
    <Footer />
    {showWhatsApp && <WhatsAppButton />}
  </div>
);

export default PageLayout;
